
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'UI_Navbar',
  props: {
    theme: String
  }
})
